// OvulationCalculator.js
import React, { useState } from "react";
import MainCalculatorsList from './MainCalculators';
import RelatedLinks from '../RelatedLinks';
import { SecondAds, FirstAds, MobileUnderCalAds } from '../../Ads';
import { SERVER_URL } from './ConstantsWomenCalculator';
import { Ovulation_EndPoint } from './ConstantsWomenCalculator';
import { OvulationTableFull } from "./Tables";
import { CyrcleLengthcomponet } from "./Component";
import SharedHelmet from "../Helmet";
const TITLE = 'Kalkulator Ovulasi - Hitung Hari Ovulasi dan Hubungan Intim';
const DESCRIPTION = 'Hitung hari ovulasi dan peluang kehamilan yang tepat pada wanita serta mengetahui waktu yang tepat untuk berhubungan intim agar terjadi kehamilan menggunakan kalkulator ovulasi.';
const KEYWORDS = 'kalkulator waktu ovulasi, hitung hari ovulasi, kalkulator ovulasi akurat, peluang terjadi kehamilan, waktu ovulasi, meningkatkan peluang kehamilan, masa ovulasi, hitung ovulasi untuk kehamilan, siklus menstruasi';
const OG_URL = 'https://do-calculate.com/calculator/id/ovulation/';
const apiEndpoint = `${SERVER_URL}/${Ovulation_EndPoint}`;
function OvulationCalculator() {
    const [firstDayOfLastPeriod, setFirstDate] = useState();
    const [periodLength, setPeriodLength] = useState(1);
    const [cycleLength, setCyrcleLength] = useState(28);
    const [result, setRestul] = useState(null);
    const [error, setError] = useState(null);
    const [statusCode, setStatusCode] = useState(null);
    const [classification, setClassification] = useState(null)
    const handleDateChange = (event) => {
        setFirstDate(event.target.value)
    };
    const calculateOvulation = async () => {
        try {
            const response = await fetch(apiEndpoint, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ firstDayOfLastPeriod, cycleLength, periodLength }),
            });
            const data = await response.json();
            setStatusCode(response.status);
            if (response.ok) {
                setRestul(data.result);
                setError(null);
            } else {
                setRestul(null);
                setError(data.error);
            }
        } catch (error) {
            console.error(error);
        }
    };
    return (
        <div>
            <SharedHelmet
                TITLE={TITLE}
                DESCRIPTION={DESCRIPTION}
                KEYWORDS={KEYWORDS}
                OG_URL={OG_URL}
            />
            <div className="row">
                <div className="col-12 col-md-8">
                    <FirstAds />
                </div>
            </div>
            <div className="row">
                <div className="col-12 col-md-8">
                    <div className="bg-success text-white text-center" style={{ height: '40px', }}><b>
                        <h1 style={{ fontSize: '15px' }}>Kalkulator Ovulasi | Cara Menghitung Hari Ovulasi dan Peluang Kehamilan
                        </h1>
                    </b></div>
                    <div className="border border-light">
                        <div className="row">
                            <div>
                                Kalkulator ovulasi digunakan untuk menentukan hari ovulasi pada wanita, yaitu hari-hari yang mewakili masa subur optimal, di mana peluang terjadinya kehamilan meningkat secara signifikan. Waktu menstruasi dan durasi siklus menstruasi berbeda antar wanita, yang menyebabkan perbedaan masa ovulasi dan masa subur dari satu wanita ke wanita lain. Dalam siklus menstruasi standar 28 hari, masa ovulasi biasanya dimulai sekitar 14 hari setelah hari pertama menstruasi. Perlu dicatat bahwa masa subur biasanya berlangsung hingga lima hari sebelum ovulasi dan tiga hari setelahnya, di mana kemungkinan kehamilan berada pada puncaknya.
                            </div>
                            <div>
                                Kalkulator masa ovulasi dan kesuburan adalah alat penting yang membantu Anda menemukan waktu ketika kesuburan Anda berada pada tingkat tertinggi, melipatgandakan peluang Anda untuk hamil. Cukup masukkan informasi yang diperlukan untuk mendapatkan perkiraan akurat masa ovulasi dan masa subur Anda.
                            </div>
                            <hr />
                            <br />
                        </div>
                        <MobileUnderCalAds />
                        <div className="row">
                            <div className='col-12 col-md-5 calculatorStyle'>
                                <div className='p-3 mb-2 bg-success text-white'>
                                    <h2 style={{ fontSize: '15px' }}>Kalkulator Hari Ovulasi</h2>
                                </div>
                                <hr />
                                <br />
                                <div className=" form-group d-flex align-items-center">
                                    <b>  <label className="form-label ms-2" >
                                        <strong>Hari pertama</strong> haid terakhir Anda:
                                    </label>
                                    </b>
                                    <br />
                                    <input
                                        type="date"
                                        id="weightNumber"
                                        value={firstDayOfLastPeriod}
                                        onChange={handleDateChange}
                                        className="form-control ml-2"
                                        style={{ width: '145px' }}
                                        placeholder="175"
                                    />
                                </div>
                                <br />
                                <div className="form-group d-flex align-items-center">
                                    <b>  <label htmlFor="CycleLength" className="form-label ms-2">
                                        Rata-rata waktu antar siklus
                                    </label>
                                    </b>
                                    <CyrcleLengthcomponet handleDateChange={setCyrcleLength} />
                                    <div className="input-group-append">
                                        <span className="input-group-text ">Hari</span>
                                    </div>
                                </div>
                                <br />
                                <hr />
                                <div>
                                    <button className="btn btn-success" style={{ fontSize: '20px' }} onClick={
                                        calculateOvulation}>Hitung</button>
                                </div>
                            </div>
                            <div className="col-sm-12 col-md-7">
                                <br />
                                {statusCode === 400 && <div className="alert alert-warning"><b><u> Terjadi Kesalahan :</u></b> Harap masukkan semua kolom dengan benar. </div>}
                                {result &&
                                    (
                                        <div>
                                            <h4><div className="p-3 mb-2 bg-success text-white">Hasil: </div></h4>
                                            <hr />
                                            <OvulationTableFull result={result}></OvulationTableFull>
                                        </div>
                                    )}
                            </div>
                        </div>
                        <hr />
                        <div className="row">
                            <RelatedLinks />
                            <hr />
                        </div>
                    </div>
                </div>
                <div className="col" >
                    <SecondAds />
                    <br />
                    <MainCalculatorsList />
                    <br />
                </div>
            </div>
            <div className="row" style={{ height: 'auto' }} >
                <div className="col-12 col-md-8">
                    <div className="info-sections-container">
                        <div className="info-section">
                            <div className="info-section-header">Deskripsi Kalkulator Ovulasi :</div>
                            <div className="info-section-body">
                                <h2 style={{ fontSize: '15px' }}>Bagaimana Kehamilan Terjadi pada Wanita</h2>
                                <p>
                                    Kehamilan pada wanita terjadi ketika sperma pria membuahi sel telur matang yang keluar dari ovarium wanita selama masa ovulasi. Sel telur ini hidup untuk waktu yang sangat singkat antara 12 hingga 24 jam. Agar kehamilan terjadi, hubungan intim harus dilakukan pada waktu ovulasi, di mana peluang kehamilan berada pada tingkat tertinggi. Kalkulator ovulasi digunakan untuk menentukan masa optimal ini, membantu dalam perencanaan keluarga atau meningkatkan peluang kehamilan.
                                </p>
                                <u><b>Ovulasi dan Pembuahan</b></u>
                                <br />
                                <p>
                                    Pada manusia, ovulasi adalah proses di mana sel telur matang dilepaskan dari ovarium. Ovulasi biasanya terjadi 14 hari sebelum dimulainya siklus menstruasi berikutnya. Dengan menggunakan kalkulator ovulasi, hari-hari paling subur dapat diprediksi. Periode antara hari ke-10 dan ke-18 dari siklus menstruasi adalah yang paling mungkin terjadi ovulasi. Selama periode ini, sperma dapat bertahan di saluran reproduksi wanita hingga lima hari, meningkatkan peluang kehamilan.
                                </p>
                                <u><b>Memprediksi Ovulasi</b></u>
                                <br />
                                <p>
                                    Kalkulator ovulasi adalah alat penting untuk memprediksi hari menstruasi dan hari ovulasi yang paling mungkin. Kalkulator ini didasarkan pada pengetahuan hari pertama siklus menstruasi dan panjang siklus menstruasi. Dengan menggunakan informasi ini, hari ovulasi dapat dihitung secara akurat, membantu wanita menentukan waktu terbaik untuk berhubungan intim untuk mencapai atau menghindari kehamilan. Prediksi ini membantu meningkatkan peluang kehamilan ketika diinginkan.
                                </p>
                                <hr />
                                <h2 style={{ fontSize: '15px' }}>Cara Menghitung Hari Ovulasi</h2>
                                <p>
                                    Masa ovulasi biasanya berlangsung antara 12 hingga 24 jam. Meskipun sulit menentukan periode ini dengan akurasi sempurna, kalkulator ovulasi digunakan untuk memperkirakan waktu yang paling tepat. Prosesnya didasarkan pada menghitung periode antara menstruasi, dan menambahkan periode ini ke tanggal hari pertama haid terakhir. Setelah itu, dua minggu dikurangkan dari tanggal yang diharapkan, dengan mempertimbangkan lima hari sebelum dan dua hari setelah tanggal ini sebagai perkiraan masa ovulasi. Kalkulator ovulasi membantu menentukan periode ini secara akurat, memudahkan untuk mengetahui hari-hari paling tepat untuk terjadinya kehamilan.
                                </p>
                                <hr />
                                <h2 style={{ fontSize: '15px' }}>Program Kalkulator Hari Ovulasi</h2>
                                <p>
                                    Program kalkulator hari ovulasi adalah alat yang didasarkan pada data yang dimasukkan tentang tanggal hari pertama haid terakhir dan panjang siklus menstruasi. Program ini memberikan informasi akurat tentang masa ovulasi, membantu wanita menentukan hari-hari di mana peluang kehamilan meningkat selama hubungan intim. Kalkulator ovulasi dapat digunakan baik dengan kalender Masehi maupun Hijriah, memberikan fleksibilitas dan akurasi dalam menghitung masa ovulasi.
                                </p>
                                <hr />
                                <h2 style={{ fontSize: '15px' }}>Menggunakan Kalkulator Ovulasi</h2>
                                <p>
                                    Untuk menggunakan kalkulator ovulasi, seorang wanita perlu mengetahui tanggal hari pertama haid terakhir dan durasi siklus menstruasi. Dengan memasukkan data ini ke dalam kalkulator, masa ovulasi dapat dihitung dengan mudah dan akurat dalam beberapa detik. Perhitungan ini penting untuk meningkatkan peluang kehamilan atau untuk perencanaan keluarga secara alami.
                                </p>
                                <br />
                                <hr />
                                <b>Tanggal peninjauan terakhir :</b>28/02/2026
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
export default OvulationCalculator;